import type { FC, ReactElement } from "react"

import { buildCssClassName } from "@/3514/utils"

type TProps = { className?: string; animationCssIdentifier: string }

const Icon: FC<TProps> = ({ className = String(""), animationCssIdentifier }: TProps): ReactElement => (
    <svg
        className={buildCssClassName({ [className]: className })}
        xmlns="http://www.w3.org/2000/svg"
        width="63"
        height="20"
        viewBox="0 0 63 10"
        fill="none"
    >
        <defs>
            <linearGradient id="dotGradient" x1="0" y1="0" x2="0" y2="10" gradientUnits="userSpaceOnUse">
                <stop stopColor="#6868E0" />
                <stop offset="1" stopColor="#0404CB" />
            </linearGradient>
        </defs>

        <circle className={animationCssIdentifier} cx="5.44" cy="5" r="5" fill="url(#dotGradient)" />
        <circle className={animationCssIdentifier} cx="18.47" cy="5" r="5" fill="url(#dotGradient)" />
        <circle className={animationCssIdentifier} cx="31.5" cy="5" r="5" fill="url(#dotGradient)" />
        <circle className={animationCssIdentifier} cx="44.53" cy="5" r="5" fill="url(#dotGradient)" />
        <circle className={animationCssIdentifier} cx="57.56" cy="5" r="5" fill="url(#dotGradient)" />
    </svg>
)

Icon.displayName = "WaveLoaderIcon"

export { Icon as WaveLoaderIcon }
